$('.highlight-filter-type').on('click', function() {
  if (navigator.geolocation) {
    try {
      navigator.geolocation.getCurrentPosition(submitFilter);
    } catch(error) {
      switch(error.code) {
      case error.PERMISSION_DENIED:
        alert("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        alert("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        alert("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        alert("An unknown error occurred.");
        break;
      }
    }
  } else { 
    console.log("Geolocation is not supported by this browser.");
  }
})

function submitFilter(position) {
  let latLong, actionUrl, filterType, input;
  latLong = [position.coords.latitude, position.coords.longitude]
  input   = $('.highlight-filter-type')

  if (latLong == undefined) {
    latLong = [3.191996399999999, 101.6170093];
    // latLong = [4.2105, 101.9758];
  }

  actionUrl  = input.data('action-url');
  filterType = input.data('filter-type');

  if (filterType == 'nearby') {
    window.location.href = `${actionUrl}&latitude=${latLong[0]}&longitude=${latLong[1]}`;
  } else {
    window.location.href = actionUrl;
  }
}
